/**
 * avatarSrc — turn a stored avatar URL into a render-safe `<img src>`.
 *
 * The User row's `updatedAt` ticks every time the row mutates (Prisma
 * `@updatedAt`), so appending it as a query string forces browsers and any
 * CDN in front of R2 to revalidate the resource after a profile edit.
 *
 * `data:` URLs are returned untouched — they are not cached by URL.
 * Existing query strings are preserved so signed URLs keep working.
 */
export function avatarSrc(
  url: string | null | undefined,
  version: string | number | null | undefined,
): string | null {
  if (!url) return null;
  if (url.startsWith('data:')) return url;
  if (!version) return url;
  const sep = url.includes('?') ? '&' : '?';
  const token = typeof version === 'string' ? Date.parse(version) || version : version;
  return `${url}${sep}v=${encodeURIComponent(String(token))}`;
}
